module.exports = __webpack_public_path__ + "img/logo_login.b21a77e8.png";